"use client";

import { ThumbnailType } from "@/sections/BaliBanner";
import { YouTubeEmbed } from "@next/third-parties/google";
import CustomImage from "../CustomImage";
import { useState } from "react";
import { AnimatePresence } from "framer-motion";
import dynamic from "next/dynamic";
import CloseIcon from "@/public/assets/images/X.svg";

const DynamicModal = dynamic(() => import("../Modal"), { ssr: false });

type BaliVideoProps = {
  videoId: string;
  thumbnail: ThumbnailType;
};

const BaliVideo = ({ videoId, thumbnail }: BaliVideoProps) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  return (
    <>
      <div className="bali-video center">
        <button
          className="bali-video__button"
          onClick={() => {
            setIsModalOpen(true);
            document.body.classList.add("no-scroll");
          }}
        >
          <CustomImage
            alt={thumbnail.alt}
            src={thumbnail.src.desktop}
            srcTablet={thumbnail.src.tablet}
            srcMobile={thumbnail.src.mobile}
            className="image--bg"
            isPriority
          />
        </button>
      </div>
      <AnimatePresence initial={false} onExitComplete={() => null}>
        {isModalOpen && (
          <DynamicModal
            isDarkerBackdrop
            handleClose={() => {
              setIsModalOpen(false);
              document.body.classList.remove("no-scroll");
            }}
          >
            <div className="bali-video__modal">
              <div className="bali-video__modal-content">
                <button
                  onClick={() => {
                    setIsModalOpen(false);
                    document.body.classList.remove("no-scroll");
                  }}
                  className="bali-video__modal-close"
                >
                  <CloseIcon />
                </button>
                <YouTubeEmbed videoid={videoId} />
              </div>
            </div>
          </DynamicModal>
        )}
      </AnimatePresence>
    </>
  );
};

export default BaliVideo;
